var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "info--template page-template page-transition" },
          [
            _c("div", { staticClass: "relative" }, [
              _c("div", { staticClass: "relative z-3000" }, [
                _c(
                  "section",
                  {
                    staticClass:
                      "relative mw12 flex flex-row z-1 z-content bg-beige",
                    attrs: { id: _vm.page.faq_section.slug },
                  },
                  [
                    _vm.isWindowWidthMobile == true
                      ? _c("div", { staticClass: "bg-cream w-100 dn-ns" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "container-fluid bg-cream relative z-4 overflow-hidden",
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "f39px pb4 pt4 black-bottom is-blenny is-navy",
                                  attrs: { id: _vm.page.faq_section.slug },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.page.faq_section.title) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "mobileFAQContainer",
                              staticClass: "relative acc-height info-bb",
                              style: { "min-height": _vm.mobileMinHeight() },
                            },
                            [
                              _vm._l(
                                _vm.page.faq_section.faq_topics,
                                function (faq_topic, key) {
                                  return _c(
                                    "div",
                                    {},
                                    _vm._l(
                                      faq_topic.faqs,
                                      function (questions) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-100 container-fluid question-answer",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "db pv4 f4 no-underline",
                                                attrs: { to: "questions" },
                                              },
                                              [
                                                questions.noDrop
                                                  ? _c("p", {
                                                      staticClass:
                                                        "f4 is-tablet-regular pt4 cms-content",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.marked(
                                                            questions.noDrop
                                                          )
                                                        ),
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                questions.header
                                                  ? _c("h1", {
                                                      staticClass: "is-red",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          questions.header
                                                        ),
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "accordion",
                                                  {
                                                    attrs: {
                                                      type: "desktop-info",
                                                      closed: true,
                                                      mobileFaqAnswerExpanded:
                                                        _vm.mobileFaqAnswerExpanded,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      {
                                                        slot: "parent-nav-link",
                                                      },
                                                      [
                                                        _c(
                                                          "h4",
                                                          {
                                                            staticClass:
                                                              "f3 is-tablet-bold is-navy mr3 w-100",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  questions.question
                                                                ) +
                                                                "\n                                "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "sub-nav-links" },
                                                      [
                                                        questions.answer_text
                                                          ? _c("div", {
                                                              staticClass:
                                                                "f4 is-tablet-regular cms-content pt4",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.marked(
                                                                      questions.answer_text
                                                                    )
                                                                  ),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c("hr"),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isWindowWidthMobile == false
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "dn relative flex-ns flex-grow-1 flex-col",
                            attrs: { id: _vm.page.faq_section.slug },
                          },
                          [
                            _c("div", { staticClass: "w-100 pl5" }, [
                              _c("div", { staticClass: "h-100" }, [
                                _c(
                                  "div",
                                  { staticClass: "info-bg sticky-nav" },
                                  [
                                    _c("div", { staticClass: "pr5" }, [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "f64px mb4 is-blenny is-navy",
                                          attrs: {
                                            id: _vm.page.faq_section.slug,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.page.faq_section.title
                                              ) +
                                              " \n                      "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "w-100 is-black" }, [
                              _c(
                                "div",
                                { staticClass: "pl4 pr6 mt4 mb5 z-4 relative" },
                                _vm._l(
                                  _vm.page.faq_section.faq_topics,
                                  function (faq_topic, key) {
                                    return _c(
                                      "div",
                                      { staticClass: "z-4 relative" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.desktopActive == key,
                                                expression:
                                                  "desktopActive == key",
                                              },
                                            ],
                                            staticClass: "b--is-black-50 bb",
                                            attrs: { id: faq_topic.slug },
                                          },
                                          _vm._l(
                                            faq_topic.faqs,
                                            function (questions) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "b--is-black-50 bb pv4",
                                                },
                                                [
                                                  questions.noDrop
                                                    ? _c("div", {
                                                        staticClass:
                                                          "f4 is-tablet-regular pt4 lh-20px cms-content",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.marked(
                                                              questions.noDrop
                                                            )
                                                          ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  questions.header
                                                    ? _c("h1", {
                                                        staticClass: "is-red",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            questions.header
                                                          ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "accordion",
                                                    {
                                                      attrs: {
                                                        type: "desktop-info",
                                                        closed: true,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        {
                                                          slot: "parent-nav-link",
                                                        },
                                                        [
                                                          _c(
                                                            "h4",
                                                            {
                                                              ref: questions.question,
                                                              refInFor: true,
                                                              staticClass:
                                                                "f3 is-tablet-bold is-navy pb1 mr4",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    questions.question
                                                                  ) +
                                                                  "\n                            "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        {
                                                          slot: "sub-nav-links",
                                                        },
                                                        [
                                                          questions.answer_text
                                                            ? _c("div", {
                                                                staticClass:
                                                                  "f4 is-tablet-regular pt4 lh-20px cms-content",
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.marked(
                                                                        questions.answer_text
                                                                      )
                                                                    ),
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "relative pb4 ph0 pr5-ns bg-beige" }, [
              _c("div", {
                staticClass:
                  "f15px m5 margin-px is-tablet-regular link-bold lh-copy cms-content",
                domProps: { innerHTML: _vm._s(_vm.marked(_vm.page.news)) },
              }),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }